import { Helmet } from 'react-helmet-async'

const SITE_URL  = import.meta.env.VITE_SITE_URL || ''
const SITE_NAME = 'Rose Gold Team'

export default function PageSeo({
  title,
  description,
  path       = '',
  image,
  type       = 'website',
  jsonLd,
  noindex    = false,
}) {
  const fullTitle  = title ? `${title} | Rose Gold Team` : SITE_NAME
  const canonical  = SITE_URL ? `${SITE_URL}${path}` : null
  const ogImage    = image || (SITE_URL ? `${SITE_URL}/images/og-default.jpg` : null)

  return (
    <Helmet>
      <title>{fullTitle}</title>
      {description && <meta name="description" content={description} />}
      {noindex && <meta name="robots" content="noindex,nofollow" />}
      {canonical && <link rel="canonical"          href={canonical} />}
      {canonical && <link rel="alternate" hrefLang="hu" href={canonical} />}
      {canonical && <link rel="alternate" hrefLang="x-default" href={`${SITE_URL}/`} />}

      {/* Open Graph */}
      <meta property="og:type"        content={type} />
      <meta property="og:title"       content={fullTitle} />
      {description && <meta property="og:description" content={description} />}
      {canonical  && <meta property="og:url"          content={canonical} />}
      {ogImage    && <meta property="og:image"        content={ogImage} />}
      <meta property="og:site_name"   content={SITE_NAME} />
      <meta property="og:locale"      content="hu_HU" />

      {/* Twitter */}
      <meta name="twitter:card"        content="summary_large_image" />
      <meta name="twitter:title"       content={fullTitle} />
      {description && <meta name="twitter:description" content={description} />}
      {ogImage     && <meta name="twitter:image"       content={ogImage} />}

      {/* Structured data */}
      {jsonLd && (
        <script type="application/ld+json">
          {JSON.stringify(jsonLd)}
        </script>
      )}
    </Helmet>
  )
}
